import React, { useContext, useEffect } from "react";
import { Navigate } from "react-router-dom";
import jwt_decode from "jwt-decode";

import { localData } from "../../Services/AuthHeader";

function PrivateRoute(props) {
  const gettoken = localData();
console.log("gettoken");


  if (gettoken) {
    console.log("gettokens",props);
    return props.children;
  }
  return <Navigate to={'/login'} replace={true} />;
}

export default PrivateRoute;
